// extracted by mini-css-extract-plugin
export default {"entries":"PaginationFunding_entries__lPUwm"};